/**
 * @file i18n messages
 * @author Box
 */

import { defineMessages } from 'react-intl';

const messages = defineMessages({
    menuButtonArialLabel: {
        id: 'boxui.media.menuButtonArialLabel',
        defaultMessage: 'Options',
        description: 'Label for comment options menu',
    },
});

export default messages;
